import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { isAuthenticated, getLoggedInBruger, isImpersonating, erElev } from './Security';

export interface PrivateRouteProps {
    component?: React.ComponentType<RouteComponentProps<any> | {}>;
    render?: any;
    exact?: boolean;
    path?: string;
    location: any;
}

export function PrivateRoute(props: PrivateRouteProps) {
    if (isAuthenticated()) {
        if (!getLoggedInBruger().accepteretVilkaar && !isImpersonating() && !erElev() ) {
            return (
                <Redirect 
                    to={{
                        pathname: '/brugervilkaar',
                        state: { from: props.location, forceAcceptBrugervilkaar: true }
                    }}
                />
            );
        } else {
            return <Route exact={props.exact} path={props.path} component={props.component} render={props.render}/>;
        }
    } else {
        return (
            <Redirect 
                to={{
                    pathname: '/login',
                    state: { from: props.location }
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/PrivateRoute.tsx